var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlockquote = function SvgBlockquote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38 7.714 0h13.5l-5.143 38H0Zm23.786 0L31.5 0H45l-5.143 38H23.786Z",
    fill: "#CE1050"
  })));
};

export default SvgBlockquote;